

























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import LockedAccountIcon from '~/components/NewWallet/LockedAccountIcon.vue';
import TriggerWalletCreationBtn from '~/components/NewWallet/TriggerWalletCreationBtn.vue';

@Component({
  components: {
    LockedAccountIcon,
    TriggerWalletCreationBtn,
  },
})
export default class IncompleteAccountWidget extends Vue {
  @State(profile => profile.isFetching, { namespace: 'profile' })
  readonly fetchingUserInfo!: boolean;

  @Prop(String) readonly displayName!: string;
  @Prop(String) readonly firstName!: string;

  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        const blueProgressBar = this.$refs.blueProgressBar as HTMLElement;

        if (blueProgressBar) {
          blueProgressBar.classList.value =
            blueProgressBar.classList.value + 'blue-progress-bar';
        }
      }, 600);
    });
  }
}
